import { useGovernedRefetchInterval } from "src/hooks/use-governed-refetch-interval";

/**
 * Hasura row poll on the library and the details page. The webhook is what
 * writes template status, category and quality; this is how long the page
 * waits to notice one of those writes.
 *
 * Pinned like the WhatsApp sender surfaces: base and ceiling are the same
 * value so the governed hook cannot stretch the interval.
 */
export const WHATSAPP_TEMPLATE_ROW_POLL_MS = 30_000;

export function useWhatsAppTemplateRowPoll<TData>() {
  return useGovernedRefetchInterval<TData>({
    baseMs: WHATSAPP_TEMPLATE_ROW_POLL_MS,
    maxMs: WHATSAPP_TEMPLATE_ROW_POLL_MS,
  });
}
